import React, { Component } from 'react';
import Swal from 'sweetalert2';
import { store } from '../store';
import AuthenticationApiServices from './AuthenticationApiServices';
class CountdownTimer extends Component { 
  constructor(props) {
    super(props);
    this.state = {
      targetDate: new Date(props.sessionTime), // Replace with your target date and time//'2023-10-05T11:00:00'
      //targetDate: new Date('2023-10-05T13:23:00'), // Replace with your target date and time//'2023-10-05T11:00:00'
      timeRemaining: {},
      timeRemaining2:{}
    };
    this.calculateTimeRemaining = this.calculateTimeRemaining.bind(this);
  }
  componentDidMount() {
    this.interval = setInterval(this.calculateTimeRemaining, 1000); 
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  calculateTimeRemaining() {
    const { targetDate } = this.state;
    const now = new Date();
    const timeDifference = targetDate - now;   
    if(this.state.timeRemaining.minutes===3&&this.state.timeRemaining.seconds===20)
    {
      const { targetDate } = this.state;
      const now = new Date();
      const timeDifference = targetDate - now;   
      const days1 = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours1 = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes1 = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds1 = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.setState({ timeRemaining2: { days1,hours1, minutes1, seconds1 } });
      this.interval2 = setInterval(this.interval,1000); 
      Swal.fire({
        title: `Do you want to Reaload Your  Session `,//${this.state.timeRemaining.minutes }:${this.state.timeRemaining.seconds}
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Continue',
        cancelButtonText: 'Cancel',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          let payload = {
            refreshToken: localStorage.getItem("token") //logindetails.accessToken
          }
          AuthenticationApiServices.RefreshTokenPost(payload).then((res) => {
            if (res.data.scode === "1") {
              localStorage.setItem("token", res.data.accessToken);
              let jsonData = {};
              store.dispatch({ type: "LOGIN_DETAILS", payload: { isLoggedIn: true, user: jsonData, token: res.data.accessToken, userLoginDetials: res.data } });
             window.location.reload(true)
            }
            else { Swal.fire('Canceled', 'Something went wrong,Please check', 'error'); }
          }).catch(() => { });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          window.location.href = "/loginpage/main";
        }
      })
    }
    if (timeDifference <= 0) {
      clearInterval(this.interval);
      this.setState({ timeRemaining: { days: 0, hours: 0, minutes: 0, seconds: 0 } });
      window.location.href = "/loginpage/main";   
    } 
    else {
      const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.setState({ timeRemaining: { days,hours, minutes, seconds } });
    }
  }
  render() {
    const { timeRemaining } = this.state;
    return (
      <div style={{marginTop:"7px" ,color:"red"}} >
         <i className="fa fa-clock-o" aria-hidden="true" style={{color:"red"}} /> Session Time&nbsp;
        <span style={{color:"red"}}>{timeRemaining.minutes}:{timeRemaining.seconds}</span>
      </div>
    );
  }
}

export default CountdownTimer;
